import React from 'react';
import PropTypes from 'prop-types';
import PromotionBanner from '../../../shared/components/PromotionBanner/PromotionBanner';
import ProductInfoBanner from '../../../shared/components/ProductInfoBanner/ProductInfoBanner';


const DetailsInfoBanners = function DetailsInfoBanners({
  infoBanner,
  promotionBanners,
}) {
  if (infoBanner.message) {
    return <ProductInfoBanner {...infoBanner} />;
  }

  if (promotionBanners.length > 0) {
    return promotionBanners.map(promotion => (
      <PromotionBanner markdown={promotion.details} key={promotion.id} />
    ));
  }

  return null;
};

DetailsInfoBanners.propTypes = {
  infoBanner: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  promotionBanners: PropTypes.arrayOf(PropTypes.shape({})),
};

DetailsInfoBanners.defaultProps = {
  promotionBanners: [],
};

export default DetailsInfoBanners;
